@if (lesson) {
<div class="w-full h-full flex flex-col">
  <!-- Header do Vídeo -->
  <app-lesson-header
    icon="bi-play-circle"
    iconColor="text-blue-500"
    [title]="lesson.title"
    [subtitle]="lesson.description"
  >
  </app-lesson-header>

  <!-- Player de Vídeo ou Mensagem de Erro -->
  @if (safeVideoUrl) {
  <div class="flex-1 min-h-0">
    <iframe
      class="w-full h-full block"
      [src]="safeVideoUrl"
      [title]="lesson.title"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    >
    </iframe>
  </div>
  } @else {
  <div
    class="flex-1 min-h-0 flex items-center justify-center bg-gray-50 dark:bg-neutral-900"
  >
    <div class="text-center">
      <i
        class="bi bi-play-circle text-gray-400 dark:text-neutral-600 text-6xl mb-4"
      ></i>
      <p class="text-gray-500 dark:text-neutral-400">Vídeo não disponível</p>
      @if (lesson.videoUrl) {
      <p class="text-xs text-gray-400 dark:text-neutral-500 mt-2">
        URL inválida: {{ lesson.videoUrl }}
      </p>
      }
    </div>
  </div>
  }
</div>
} @else {
<div
  class="w-full h-full flex items-center justify-center bg-gray-50 dark:bg-neutral-900"
>
  <div class="text-center">
    <i
      class="bi bi-play-circle text-gray-400 dark:text-neutral-600 text-6xl mb-4"
    ></i>
    <p class="text-gray-500 dark:text-neutral-400">Vídeo não disponível</p>
  </div>
</div>
}
